import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { json } from '@codemirror/lang-json';
import {
    defaultHighlightStyle,
    foldGutter,
    syntaxHighlighting,
} from '@codemirror/language';
import { MergeView } from '@codemirror/merge';
import { EditorState } from '@codemirror/state';
import { EditorView, lineNumbers } from '@codemirror/view';

@Component({
    selector: 'wdx-json-diff',
    standalone: true,
    template: `<div #jsonDiffContainer class="wdx-json-diff-container"></div>`,
    styleUrls: ['./wdx-json-diff.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WdxJsonDiffComponent
    implements AfterViewInit, OnDestroy, OnChanges
{
    @Input() leftData!: { [key: string | number]: any };
    @Input() rightData!: { [key: string | number]: any };
    @Input() collapseUnchanged = false;

    @ViewChild('jsonDiffContainer', { static: true })
    jsonDiffContainer!: ElementRef;

    private mergeView!: MergeView;
    private editorState = {
        extensions: [
            lineNumbers(),
            json(),
            foldGutter(),
            syntaxHighlighting(defaultHighlightStyle, { fallback: true }),
            EditorView.editable.of(false),
            EditorState.readOnly.of(true),
            EditorView.theme({
                '&': { height: '100%' },
                '.cm-scroller': { overflow: 'auto' },
            }),
        ],
    };

    ngAfterViewInit(): void {
        this.initMergeView();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            this.mergeView &&
            (changes['leftData'] ||
                changes['rightData'] ||
                changes['collapseUnchanged'])
        ) {
            this.mergeView.destroy();
            this.initMergeView();
        }
    }

    private initMergeView(): void {
        this.mergeView = new MergeView({
            gutter: true,
            parent: this.jsonDiffContainer.nativeElement,
            collapseUnchanged: this.collapseUnchanged
                ? { margin: 0, minSize: 1 }
                : undefined,
            a: {
                doc: JSON.stringify(this.leftData, null, 2),
                ...this.editorState,
            },
            b: {
                doc: JSON.stringify(this.rightData, null, 2),
                ...this.editorState,
            },
        });
    }

    ngOnDestroy(): void {
        this.mergeView?.destroy();
    }
}
